import { useQuery } from '@tanstack/react-query';
import { isApiError } from '@/shared/lib/apiClient';
import {
  PLATFORM_USAGE_QUERY_KEYS,
  PLATFORM_USAGE_REFETCH_INTERVAL_MS,
  PLATFORM_USAGE_SUMMARY_MINUTES,
} from '../constants';
import { fetchPlatformUsageSummary } from '../services/platformUsage.api';

export function usePlatformUsageSummary(
  enabled: boolean,
  minutes = PLATFORM_USAGE_SUMMARY_MINUTES,
) {
  return useQuery({
    queryKey: PLATFORM_USAGE_QUERY_KEYS.summary(minutes),
    queryFn: ({ signal }) => fetchPlatformUsageSummary(minutes, signal),
    enabled,
    staleTime: 15_000,
    refetchInterval: enabled ? PLATFORM_USAGE_REFETCH_INTERVAL_MS : false,
    refetchIntervalInBackground: false,
    retry: (failureCount, error) => {
      if (isApiError(error) && (error.status === 401 || error.status === 403)) {
        return false;
      }
      return failureCount < 1;
    },
  });
}
